import { setCookie } from '@/utils/utils'
import config from '@/utils/config'
import session from '@/auth/session'

export default [
  {
    path: '/multiempresa',
    component: () => import('@/views/MultiCompany.vue')
  },
  {
    path: '/multiempresa/logout',
    beforeEnter() {
      setCookie(config.jwtCookieName, '', 0) // Borramos la cookie
      session.destroy() // Borramos datos sesión
      if (config.promoterCode === 9902) {
        window.location.href = config.urlLogoutCas
      } else {
        window.location.href = 'https://efactura.sistemaefactura.com/'
      }
    }
  }
]
